import "./styles.css";
import { FC, useEffect, useRef, useState } from "react";
import { IconButton, styled, InputBase } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";

const Search = styled("div")<{ isActive: boolean; height: string }>(
  ({ theme, isActive, height }) => ({
    position: "relative",
    border: `1px solid ${isActive ? "#2984ff" : "#C9C6C6"}`,
    backgroundColor: "#fff",
    fontWeight: 500,
    justifySelf: "center",
    borderRadius: 8,
    marginLeft: 0,
    height: height,
    width: "100%",
    padding: 8,
    transition: "border 0.3s, background-color 0.3s",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
    },
  })
);

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-input": {
    color: "var(--zs-grey)",
    padding: "15px",
    fontSize: "13.5px",
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      "&:focus": {
        // width: "20ch",
      },
    },
  },
}));

const SearchBox: FC<{
  handleSearch: Function;
  value: string;
  placeholder?: string;
  size?: "small" | "medium";
  height?: string;
}> = ({
  placeholder,
  value,
  handleSearch,
  size = "small",
  height = "100%",
}) => {
  const searchBoxReference: any = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [localValue, setLocalValue] = useState(value ?? "");
    const location = useLocation();
  

   useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  // const handleClear = () => {
  //   handleSearch("");
  //   if (searchBoxReference?.current) searchBoxReference.current.value = "";
  //   setIsActive(false); // Reset active state
  // };
    const handleClear = () => {
    setLocalValue("");
    handleSearch("");
    setIsActive(false);
  };
  useEffect(() => {
  if (!value) {
    setLocalValue("");
    setIsActive(false);
  }
}, [location]);

  return (
    <Search className="searchInput" isActive={isActive} height={height}>
      <StyledInputBase
        id="search"
        placeholder={placeholder ?? "Search here..."}
        inputProps={{ "aria-label": "search" }}
        inputRef={searchBoxReference}
        // defaultValue={value}
        value={localValue}
        autoComplete="off"
        onFocus={() => setIsActive(true)} // Set active state on focus
        // onBlur={() => {
        //   if (!searchBoxReference?.current?.value) setIsActive(false); // Reset state if no input
        // }}
        // onKeyDown={(e) => {
        //   if (e?.key === "Enter") {
        //     handleSearch((searchBoxReference?.current?.value).trim());
        //   }
        // }}
        // onChange={(e) => {
        //   if (e?.target?.value === "" && value) handleClear();
        // }}
        onBlur={() => {
          if (!localValue) setIsActive(false);
        }}
        onChange={(e) => setLocalValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSearch(localValue.trim());
        }}
      />
      {/* {value && searchBoxReference?.current?.value && (
        <IconButton className="searchBoxIcon" onClick={() => handleClear()}>
          <CloseIcon fontSize={size} className="searchIcons" />
        </IconButton>
      )} */}
       {localValue && (
        <IconButton onClick={handleClear}>
          <CloseIcon fontSize={size} className="searchIcons" />
        </IconButton>
      )}
      <IconButton
        className="searchBoxIcon"
        // onClick={() => handleSearch((searchBoxReference?.current?.value).trim())}
        onClick={() => handleSearch(localValue.trim())}
      >
        <SearchIcon fontSize={size} className="searchIcons" />
      </IconButton>
    </Search>
  );
};

export default SearchBox;